import { Award } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { Cloud, SectionTitle, Reveal } from "./Decor";

export const AwardsSection = ({ c, s }) => {
  const items = (c?.awards || []).filter((a) => a.title || a.image);
  return (
    <section id="awards" className="relative overflow-hidden bg-gradient-to-b from-yellow-50 to-pink-50 py-16 sm:py-20" data-testid="awards-section">
      <Cloud className="drift absolute -right-10 top-12 w-36 text-white" />
      <div className="relative mx-auto max-w-6xl px-4 sm:px-6">
        <SectionTitle id="awards" title={s.title} subtitle={s.subtitle} />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((a, i) => (
            <Reveal key={a.id || i} delay={(i % 3) * 0.08} className="group overflow-hidden rounded-[2rem] bg-white shadow-sm ring-1 ring-pink-100 transition-shadow duration-300 hover:shadow-lg">
              <div data-testid={`award-card-${i}`}>
                {a.image ? (
                  <div className="h-64 overflow-hidden">
                    <img src={imgUrl(a.image)} alt={a.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                ) : (
                  <div className="flex h-64 items-center justify-center bg-yellow-50"><Award className="h-14 w-14 text-orange-400" /></div>
                )}
                <div className="p-5">
                  {a.year && <span className="inline-block rounded-full bg-orange-100 px-3 py-1 text-xs font-semibold text-orange-600">{a.year}</span>}
                  <h3 className="font-display mt-3 text-lg font-semibold leading-snug text-blue-900">{a.title}</h3>
                  {a.description && <p className="mt-2 text-sm leading-relaxed text-slate-600">{a.description}</p>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
